import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Profile = createSvgIcon(
  <path d="M12 0a6 6 0 0 0-6 6v1.5c0 1.825.815 3.46 2.101 4.56A9.752 9.752 0 0 0 2.25 21v3H4.5v-3a7.5 7.5 0 0 1 15 0v3h2.25v-3a9.752 9.752 0 0 0-5.851-8.94A5.987 5.987 0 0 0 18 7.5V6a6 6 0 0 0-6-6Zm0 11.25A3.75 3.75 0 0 1 8.25 7.5V6a3.75 3.75 0 1 1 7.5 0v1.5A3.75 3.75 0 0 1 12 11.25Z" />,
  'Profile'
);

export { Profile };